import { cfpBaseUrl } from '../../network/urls';

export const fetchApprovedAdvanceBill = async (applicationId, token) => {
    const response = await fetch(`${cfpBaseUrl}advancePayment/getApprovedAdvanceBill`, {
        method: 'POST',
        headers: {
            Authorization: token,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ applicationId }),
        redirect: 'follow',
    });

    const result = await response.json();

    if (result.status !== '200' && result.status !== 200) {
        throw new Error(result.message || 'Failed to load approved advance bill.');
    }

    return result;
};
